
/* eslint-disable  @typescript-eslint/naming-convention */
import Vue from 'vue';
import { Device, DeviceEdit } from '@/interfaces/locations';
import GatewayEditModal from '@/components/modal/GatewayEditModal.vue';

export default Vue.extend({
	components: {
		GatewayEditModal,
	},
	computed: {
		gateway(): Device | null {
			return this.$store.getters['devices/gateways/getGateway'](this.$route.params.gatewayId);
		},
	},
	methods: {
		back(): void {
			this.$router.push({ name: 'SiteConfiguration' });
		},
		modifyGatewayModal() {
			this.$bvModal.show('modal-gateway');
		},
		async modifyGateway(gatewayId: number, newGateway: DeviceEdit) {
			await this.$store.dispatch('devices/gateways/modifyGateway', {
				id: gatewayId,
				payload: newGateway,
			});
			this.$bvModal.hide('modal-gateway');
		},
	},
});
